import { ChannelState, RootState } from '@/types/store'
import { Module } from 'vuex'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: ChannelState = {
  isChannelLoading: false,
  channels: [],
}

export const channel: Module<ChannelState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
